<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="body-rw Part-rw auto-rw page-open-left-rw" epub:type="bodymatter part" id="part001">
<div class="ext_chp">
<div class="width-10">
<div class="pc">
<img alt="image" src="images/Art_Ptorn.jpg"/>
</div>
</div>
</div>
<h1 class="part-number"><a href="#/toc#toc-part001">PART ONE</a></h1>
<div class="ext_cha">
<div class="decoration-rw10">
<div class="media-rw image-rw float-none-rw floatgalley-none-rw align-center-rw width-fixed-rw exclude-print-rw">
<div class="pc-rw"><img alt="" src="images/Art_line.jpg"/></div>
</div>
</div>
</div>
<p class="center">Death is the Physician of the Poor</p>
<p class="center-a"><em>Liagh gach boicht bas</em></p>
<div class="ext_chb">
<div class="decoration-rw10">
<div class="media-rw image-rw float-none-rw floatgalley-none-rw align-center-rw width-fixed-rw exclude-print-rw">
<div class="pc-rw"><img alt="" src="images/Art_line1.jpg"/></div>
</div>
</div>
</div>
<p class="center"><strong>1825</strong></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?416abfce